import React from "react";
import { Localize } from "components/service";
import StaffManagementFields from "../fields";
import { adaptEvent } from "./staff-events-api-helper";


const staffManagementColumns = [
    {
        title: <Localize>STAFF_MANAGEMENT.Column_Exhibition</Localize>,
        dataIndex: "title",
        columnIndex: "TITLE",
        sorter: true,
        width: 275,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.Column_Status</Localize>,
        dataIndex: "status",
        width: 205,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.Column_Construction</Localize>,
        dataIndex: "construction",
        columnIndex: "CONSTRUCTIONSTART_AT",
        sorter: true,
        width: 193,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.Column_ExhibitionPeriod</Localize>,
        dataIndex: "exhibitionPeriod",
        columnIndex: "START_AT",
        sorter: true,
        width: 190,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.Column_Dismantling</Localize>,
        dataIndex: "dismantlingPeriod",
        columnIndex: "DISMANTLING_START_AT",
        sorter: true,
        width: 190,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.Column_Workers</Localize>,
        dataIndex: "workers",
        width: 220,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.Column_Subcontractors</Localize>,
        dataIndex: "subcontractors",
        width: 194,
    },
    {
        dataIndex: "qr",
        align: "right",
        width: 120,
    },
];

const staffManagementData = (events = []) => events.map((apiEvent) => {
    const event = adaptEvent(apiEvent);

    return {
        key: event.id,
        title: <StaffManagementFields.EventLink id={ event.id } title={ event.title } />,
        status: <StaffManagementFields.Status status={ event.lifecycle_status } />,
        construction: (
            <StaffManagementFields.Period
                startAt={ event.constructionStart_at }
                endAt={ event.constructionEnd_at } />
        ),
        exhibitionPeriod: (
            <StaffManagementFields.Period
                startAt={ event.start_at }
                endAt={ event.end_at } />
        ),
        dismantlingPeriod: (
            <StaffManagementFields.Period
                startAt={ event.dismantling_start_at }
                endAt={ event.dismantling_end_at } />
        ),
        workers: (
            <StaffManagementFields.Workers
                id={ event.id }
                count={ event.workers_count }
                onSiteCount={ event.workers_on_site_count } />
        ),
        subcontractors: (
            <StaffManagementFields.Subcontractors
                count={ event.subcontractors_count }
                subcontractors={ event.subcontractors } />
        ),
        qr: <StaffManagementFields.Qr event={ event } />,
    };
});

const StaffManagementTableHelper = {
    columns: staffManagementColumns,
    data: staffManagementData,
};

export default StaffManagementTableHelper;
